module.exports = __webpack_public_path__ + "img/speed.a49cf53b.jpg";